<template>
  <div>
    <cc-collapse :title="$t('ct-sizes')">
      <cc-slider-component ref="widthConfig"></cc-slider-component>
      <cc-slider-component ref="minWidthTabletConfig"></cc-slider-component>
    </cc-collapse>

     <!-- <cc-collapse :title="$t('ct-shadow')">
      <cc-shadow ref="shadow"></cc-shadow>
    </cc-collapse>

    <cc-collapse  :title="$t('ct-animation')">
      <cc-animation ref="animation"></cc-animation>
    </cc-collapse> -->

     <cc-collapse  :title="$t('ct-tag')">
      <cc-tag ref="tag"></cc-tag>
    </cc-collapse>

    <cc-collapse  :title="$t('ct-layers')">
      <cc-z-index ref="z-index"></cc-z-index>
    </cc-collapse>

  </div>
</template>

<script>
export default {
  name: 'CheckoutOptions',
  data() {
    return {
      config: {},
      callback: () => {}
    };
  },
  methods: {
    init(config, callback) {

      let vm = this;
      vm.config = _.clone(config);
      vm.callback = callback;

      this.$refs['widthConfig'].setValues({defaultValue: 801, defaultValueChecked: true, min: 300, max: 1920, canBeCheckbox: false, labelDesc: 'width', name: 'iconColor', callback: vm.setWidth});

      this.$refs['minWidthTabletConfig'].setValues({defaultValue: vm.config.maxWidth, defaultValueChecked: true, min: 300, max: 900, canBeCheckbox: false, labelDesc: 'max-width-tablet', name: 'iconColor', callback: vm.setMaxWidth});

      /* // shadow
      this.$refs['shadow'].setValues({defaultValue: vm.config.boxShadow, labelDesc: 'shadow', name: 'shadow', callback: vm.setShadow});

      // animation
      this.$refs['animation'].setValues({
        action: vm.config.animation.in.action,
        effect: vm.config.animation.in.effect,
        scroll: vm.config.animation.in.scroll,
        time: vm.config.animation.in.time,
        speed: vm.config.animation.in.speed,
        infinite: vm.config.animation.in.infinite,
        labelDesc: 'animate',
        name: 'animate',
        callback: vm.setAnimation
      }, null); */

      // tag
      this.$refs['tag'].setValues({tag: vm.config.tag, callback: vm.setTag});

      // z-index
      this.$refs['z-index'].setValues({defaultValue: vm.config.zIndex, callback: vm.setZIndex});
    },
    setShadow(data) {
      this.config.boxShadow = `${data.h}px ${data.v}px ${data.b}px ${data.s}px ${data.color}  ${data.inset ? 'inset' : ''}`;
      this.save();
    },
    setWidth(value) {
      this.config.width = `${value}px`;
      this.save();
    },
    setMaxWidth(value) {
      this.config.maxWidth = `${value}px`;
      this.save();
    },
    setAnimation(data) {
      this.config.animation.in = _.merge(this.config.animation.in, data);
      this.save();
    },
    setZIndex(value) {
      this.config.zIndex = value;
      this.save();
    },
    setTag(value) {
      this.config.tag = value;
      this.save();
    },
    save() {
      this.callback(this.config);
    }
  },
  beforeDestroy() {
    this.config = {};
    this.callback = () => {};
  }
};
</script>



// WEBPACK FOOTER //
// src/components/editor/apps/Checkout/Form/Options.vue